export default [
    {
        field: 'name',
        type: 'text',
        maxLength: 30,
        value: '',
        vuetifyProps: {
            label: 'Nombre Producto',
        },
        // rules: ['required'],
    },
    {
        field: 'alias_name',
        type: 'text',
        maxLength: 30,
        value: '',
        vuetifyProps: {
            label: 'Alias',
        },
        // rules: ['required'],
    },
    {
        field: 'description',
        type: 'text',
        maxLength: 100,
        value: '',
        vuetifyProps: {
            label: 'Descripción',
        },
    },
    // {
    //     field: 'upc_code',
    //     type: 'text',
    //     maxLength: 30,
    //     value: '',
    //     vuetifyProps: {
    //         label: 'Códigos upc',
    //     },
    //     // rules: ['required'],
    // },
    {
        field: 'upc_code',
        type: 'autocompleteObject',
        // value: '',
        vuetifyProps: {
            label: 'Códigos upc',
            multiple:true,
            chips:false,
            // 'deletable-chips': false,
        },
        options: {
            data: [],
            text: 'upc_code',
            value: 'index',
        },
        // rules: ['required'],
    },
    {
        field: 'internal_code',
        type: 'text',
        maxLength: 30,
        value: '',
        vuetifyProps: {
            label: 'Código interno',
        },
        // rules: ['required'],
    },
    {
        field: 'wh_family_id',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'Familia',
        },
        // options: {
        //     data: [],
        //     text: 'family',
        //     value: 'id',
        // },
    },
    {
        field: 'wh_subfamily_id',
        // type: 'autocompleteObject',
        type: 'text',
        value: '',
        vuetifyProps: {
            label: 'subFamilia',
            // 'no-data-text':'¡ Subfamilias No encontradas!' 
        },
        // options: {
        //     data: [],
        //     text: 'subfamily',
        //     value: 'id',
        // },
        // rules: ['required'],
    },
    {
        field: 'warranty_days',
        type: 'text',
        maxLength: 4,
        value: '',
        vuetifyProps: {
            label: 'Días de Garantía',
        },
        // rules: ['required'],
    },
    
    {
        field: 'sale_price',
        type: 'text',
        maxLength: 10,
        value: '',
        vuetifyProps: {
            label: 'Precio venta',
        },
        // rules: ['required'],
        format: 'currency'
    },
    {
        field: 'tags',
        type: 'autocompleteObject',
        // value: '',
        vuetifyProps: {
            label: 'Tag',
            multiple:true,
            chips:true,
            'deletable-chips': false,
        },
        options: {
            data: [],
            text: 'tag',
            value: 'id',
        },
        // rules: ['required'],
    },
    {
        field: 'wh_unit_of_measurement_id',
        type: 'text',
        maxLength: 10,
        value: '',
        vuetifyProps: {
            label: 'Unidad de medida',
        },
        // options: {
        //     data: [],
        //     text: 'name',
        //     value: 'id',
        // },
        // rules: ['required'],
    },
    {
        field: 'uom_quantity',
        type: 'text',
        maxLength: 10,
        value: '',
        vuetifyProps: {
            label: 'Cantidad minima unidad medida',
        },
        // rules: ['required'],
    },
    {
        field: 'cost_price',
        type: 'text',
        maxLength: 10,
        value: '',
        vuetifyProps: {
            label: 'Precio costo',
        },
        // rules: ['required'],
    },
    {
        field: 'minimum_stock',
        type: 'text',
        maxLength: 10,
        value: '',
        vuetifyProps: {
            label: 'Stock minimo',
        },
        // rules: ['required'],
    },
    {
        field: 'is_salable',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Vendible',
            'false-value': false,

        },
    },
    {
        field: 'is_inventoriable',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Inventariable',
            'false-value': false,
        },
    },
    {
        field: 'is_repackaged',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Es envasado',
        },
    },
    {
        field: 'is_consumable',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Consumo interno',
            'false-value': false,
        },
    },
    {
        field: 'have_decimal_quantity',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Posee cantidad decimal',
        },
    },
    {
        field: 'is_seasonal',
        type: 'checkbox',
        value:false,
        vuetifyProps: {
            label: 'Producto temporada',
            'false-value': false,
        },
    },
    {
        field: 'is_tax_free',
        type: 'checkbox',
        value: false,
        vuetifyProps: {
            label: 'Libre de impuesto',
        },
    },
]